/**
 * The company the user explicitly chose, as found in the current company
 * list. Returns null when nothing was chosen yet, or when the stored choice
 * isn't part of the list anymore (e.g. another user logged in on the same
 * browser) — the app must ask the user instead of guessing a company.
 */
export const selectedCompany = ({ company: { selected, list } }) => {
  if (!selected) return null

  return (list || []).find((i) => i.id === selected.id) || null
}

/**
 * What the app should do before rendering company-scoped screens:
 * - `loading`: company list not loaded yet
 * - `error`: company list failed to load
 * - `ready`: a valid company is selected (or the database has no companies)
 * - `auto`: there's exactly one company, it can be selected automatically
 * - `choose`: the user must pick a company
 */
export const companyGateStatus = (state) => {
  const { list, listError } = state.company

  if (!list) return listError ? 'error' : 'loading'
  if (!list.length || selectedCompany(state)) return 'ready'
  if (list.length === 1) return 'auto'
  return 'choose'
}
